module.exports = __webpack_public_path__ + "static/media/logo.9a87a1eb.png";